$(function(){
  $('.select-for-colegio').on('change',function(){
    var $url = $(this).val();
    window.location.replace($url); 
  })
});
